<template>
    <div>
        <div
            v-if="!hasContactInfoChanged"
            class="d-flex align-items-start">
            <div class="me-2">
                {{ signatory.Tag }}
            </div>
            <div>
                {{ formatSignatoryContactInfoString(previousContactInfo) }}
            </div>
        </div>
        <!-- Contact info updated -->
        <div
            v-else
            class="d-flex align-items-start justify-content-between">
            <div class="flex-grow-1 d-flex">
                <div>
                    {{ signatory.Tag }}
                </div>
                <div class="ms-2">
                    {{ formatSignatoryContactInfoString(currentContactInfo) }}
                </div>
                <div class="ms-2 text-bubble-info">
                    {{ contactInfoUpdatedText }}
                </div>
            </div>
            <pc-button
                link
                class="p-0 ms-3"
                v-on:click="toggleContactDetails">
                {{ showContactDetails ? hideOriginalContactInfoBtnLabel : showOriginalContactInfoBtnLabel }}
            </pc-button>
        </div>
        <pc-transition transition="slide">
            <div
                v-if="showContactDetails"
                class="d-flex align-items-start mt-1">
                <div class="me-2 fst-italic">
                    {{ signatory.Tag }}
                </div>
                <div class="me-2 fst-italic">
                    {{ formatSignatoryContactInfoString(previousContactInfo) }}
                </div>
                <div class="text-bubble-info">
                    {{ contactInfoOriginalText }}
                </div>
            </div>
        </pc-transition>
    </div>
</template>
<script>
    import Vuex from "vuex";
    import { isModuleRegistered } from "SharedStores/util";
    import { PROJECT_NAMESPACE, PROJECT_TYPES } from "SharedStores/Project/projectStore";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/resendContactInfoPreview.i18n";

    function areContactInfosEquivalent(contactInfo1, contactInfo2) {
        return (
            contactInfo1.first.toLowerCase() === contactInfo2.first.toLowerCase() &&
            contactInfo1.last.toLowerCase() === contactInfo2.last.toLowerCase() &&
            contactInfo1.email.toLowerCase() === contactInfo2.email.toLowerCase()
        );
    }

    export default {
        props: {
            signatory: { type: Object, required: true }
        },
        data() {
            return {
                showContactDetails: false
            };
        },
        computed: {
            signatoryDefinition() {
                return this.signatory.SignatoryDefinition;
            },
            previousContactInfo() {
                return this.createContactInfoObject(
                    this.signatory.FirstName,
                    this.signatory.LastName,
                    this.signatory.Email
                );
            },
            currentContactInfo() {
                return this.createContactInfoObject(
                    this.getProjectDataValue(this.signatoryDefinition.FirstNameDataFieldId),
                    this.getProjectDataValue(this.signatoryDefinition.LastNameDataFieldId),
                    this.getProjectDataValue(this.signatoryDefinition.EmailDataFieldId)
                );
            },
            hasContactInfoChanged() {
                return !areContactInfosEquivalent(this.previousContactInfo, this.currentContactInfo);
            },
            ...Vuex.mapGetters({
                getProjectDataValue: PROJECT_TYPES.getters.dataFieldValueFromId
            }),
            ...mapI18n({ ...KEYS }, NAMESPACE)
        },
        mounted() {
            if (!isModuleRegistered(PROJECT_NAMESPACE, this.$store.state)) {
                throw "Expected ProjectStore to be registered";
            }
        },
        methods: {
            toggleContactDetails() {
                this.showContactDetails = !this.showContactDetails;
            },
            createContactInfoObject(first, last, email) {
                first = first || this.missingContactInfoPlaceholder;
                last = last || this.missingContactInfoPlaceholder;
                email = email || this.missingContactInfoPlaceholder;

                return {
                    first,
                    last,
                    email
                };
            },
            formatSignatoryContactInfoString({ first, last, email }) {
                return this.$app.res({
                    namespace: NAMESPACE,
                    key: KEYS.formattedContactInfoTemplate,
                    values: {
                        first,
                        last,
                        email
                    }
                });
            }
        }
    };
</script>
